<template>
  <div class="progress">
    <div
      :class="`progress-bar progress-bar-striped ${barColor} ${animated ? 'progress-bar-animated' : ''}`"
      role="progressbar"
      :style="`width: ${width}`"
      :aria-valuenow="width"
      aria-valuemin="0"
      aria-valuemax="100"
    > {{ width }} </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: { type: Number, required: false },
    percentage: { type: String, required: false },
    danger: { type: String, required: false, default: 'bg-danger' },
    warning: { type: String, required: false, default: 'bg-warning' },
    success: { type: String, required: false, default: 'bg-success' },
    animated: { type: Boolean, default: false }
  },

  computed: {
    width () {
      return this.progress ? `${this.progress}%` : this.percentage || '0%'
    },
    barColor () {
      return this.progress === 100 ? this.success : this.progress >= 50 ? this.warning : this.danger
    }
  }
}
</script>
